"use strict";
// import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";
// import {
//   faCircleCalendar,
//   faCircleLocationArrow,
//   faEnvelope,
//   faFilePdf,
//   faMapLocation,
//   faMapPin,
//   faMoneyBill,
//   faPhone,
// } from "@fortawesome/pro-duotone-svg-icons";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { BadgeControl, ButtonControl, DividerControl, LabelControl, LinkButtonControl, PillsControl, Utilities } from "doshx_controls_web";
// import React, { ReactNode, useEffect, useState } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import { get_auction } from "../api/calls/auction/get_auction";
// import { setContentModal, setDrawer, setMessageModal } from "../reducers/slices/main";
// import { AppDispatch } from "../store";
// import { DisclaimerPage } from "../screens/pages/disclaimer";
// import { IAuctionSliceState, setLiveAuction } from "../reducers/slices/auction";
// import { Gallery } from "./gallery";
// import { LoaderContent } from "./loader_content";
// import { IUserSliceState } from "../reducers/slices/user";
// import { callingIcon, crossIcon, mailIcon, mapIcon, msgIcon, telegramIcon, twitterIcon, whatsappIcon } from "../../../assets/icons";
// import { AuctionRulesConditionsPage } from "../screens/pages/sign_up/auction_rules_conditions";
// import { LogInComponent } from "../screens/pages/login/login";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuctionDetailsComponent = void 0;
// interface IProps {
//   // auctionID: string;
// }
// export const AuctionDetailsComponent = (props: IProps) => {
//   // const { auctionID } = props;
//   const dispatch = useDispatch<AppDispatch>();
//   const [isLoading, setIsLoading] = useState<boolean>(true);
// const [modalIcon , setIconModal] = useState(false);
//   // Use this liveAuction to call the get_auction endpoint.
//   // This will get the auction details including the images, documents, etc.
//   const { liveAuction } = useSelector<any, IAuctionSliceState>((state: any) => state.auctionState);
//   const { user } = useSelector<any, IUserSliceState>((state: any) => state.userState);
//   const [auction, setAuction] = useState<any>();
//   useEffect(() => {
//     if (liveAuction?.entity_id) {
//       setIsLoading(true);
//     get_auction({
//         entity_id: liveAuction?.entity_id,
//         user_entity_id:user?.entity_id,
//       }).then((response) => {
//         setIsLoading  (false);
//         if (response.success) {
//           setAuction(response.content);
//         } else {
//           dispatch(
//             setMessageModal({
//               title: "Oops!",
//               messages: [
//                 "Something went wrong while we were getting the auction details.", //
//                 response.message,
//               ],
//             }),
//           );
//         }
//       });
//     }
//   }, [liveAuction?.entity_id]);
//   const shareText = `${auction?.title}
//   Description: ${auction?.description}
//   Link: ${window.location.href}`;
//    // Convert all images to a newline-separated string
//    const imageLinks = auction?.images?.map((img: any) => `🖼️ ${img.uploaded_file_url}`).join("\n");
//    // Combine details and images for sharing
//    const fullShareText = `${shareText}\n\n${imageLinks}`;
//    // Share handlers for each platform
//    const handleWhatsAppShare = () => window.open(`https://wa.me/?text=${encodeURIComponent(fullShareText)}`, "_blank");
//    const handleTwitterShare = () => window.open(`https://twitter.com/intent/tweet?text=${encodeURIComponent(fullShareText)}`, "_blank");
//    const handleTelegramShare = () => window.open(`https://t.me/share/url?text=${encodeURIComponent(fullShareText)}`, "_blank");
//    const handleEmailShare = () => window.open(`mailto:?subject=${encodeURIComponent(auction?.title)}&body=${encodeURIComponent(fullShareText)}`);
//    const handleSmsShare = () => window.open(`sms:?body=${encodeURIComponent(fullShareText)}`);
//    const handleMapShare = () => window.open(`https://maps.google.com?q=${auction?.location.latitude},${auction?.location.longitude}`, "_blank");
//    const handleCallShare = () => window.open(`tel:${auction?.contact_details?.phone?.number}`);
//    const handleWhatsAppEnquiry =() => {
//     window.open(`https://wa.me/${auction?.contact_details?.whatsapp?.number}?text=Hello`);
//    }
//    const handleCallEnquiry = () => {
//     window.open(`tel:${auction?.contact_details?.phone?.number}`);
//    }
//    const handleMailEnquiry = () => {
//     window.open(`mailto:${auction?.contact_details?.email}`);
//    }
//    const handleSmsEnquiry = () => {
//     window.open(`sms:?body=${auction?.contact_details?.phone?.number}`)
//    }
//   return (
//     <LoaderContent loading={isLoading} className="flex flex-col md:flex-row h-full gap-2">
//       <div className="flex justify-center">
//         <Gallery
//           images={auction?.images?.map((image: any, index: number) => {
//             return {
//               src: image?.uploaded_file_url,
//               alt: image?.title,
//             };
//           })}
//         />
//       </div>
//       <div className="flex-1 flex flex-col gap-2 p-4">
//         <div className="flex flex-col gap-2">
//           <div className="flex flex-row justify-between">
//             <div>
//               <div className="text-black text-xl font-bold">{auction?.title}</div>
//               <LabelControl size="xsmall" label={auction?.type} bold textColor="text-black" />
//             </div>
//             <BadgeControl
//               value={auction?.status}
//               colors={{
//                 backgroundColor: "bg-secondary",
//                 valueColor: "text-white",
//               }}
//             />
//           </div>
//           <div className="max-h-[200px] overflow-y-auto">
//             <LabelControl size="large" label={auction?.description} textColor="text-black" />
//           </div>
//           <div className="h-1 bg-gray-200 py-1 px-4 rounded-full shadow-sm"></div>
//           { auction?.auction_registered === false && <div className="flex w-full">
//                   <button
//                     className={`w-full max-w-[274px] min-h-[37px] rounded-full text-white mt-2 mb-2 text-center ${
//                        "bg-[#F04F23]"
//                     }`}
//                     // onClick={(e) => handleRegister(e, index, auction.entity_id)}
//                     // disabled={loadingIndex === index || auction.auction_registered}
//                     onClick={(e) => {
//                       e.stopPropagation();
//                       (user && user.entity_id) ? dispatch(
//                         setDrawer({
//                           open: true,
//                           // content: <RegisterBidderComponent />,
//                           content: <AuctionRulesConditionsPage registered={auction.auction_registered} auctionId={auction.entity_id}/>,
//                         }),
//                       ) :
//                       dispatch(
//                         setDrawer({
//                           open: true,
//                           content: (
//                             <div className="w-96">
//                               <LogInComponent />
//                             </div>
//                           ),
//                         }),
//                       );
//                     }}
//                   >
//                     {"Register Now!"}
//                   </button>
//                 </div>}
//           <div className="flex gap-2 items-center">
//             <span className="text-lg text-black">
//               <FontAwesomeIcon icon={faCircleLocationArrow} />
//             </span>
//             <div
//               className="cursor-pointer"
//               onClick={() => {
//                 window.open(`https://maps.google.com?q=${auction.location.latitude},${auction.location.longitude}`, "_blank");
//               }}
//             >
//               <LabelControl size="medium" label={auction?.location?.full_address} textColor="text-black" />
//             </div>
//           </div>
//           <div className="flex gap-2 items-center">
//             <span className="text-lg text-black">
//               <FontAwesomeIcon icon={faCircleCalendar} />
//             </span>
//             <LabelControl
//               size="medium"
//               label={`This auction will take place on ${Utilities.formatDateTime(
//                 auction?.date_from, //
//                 "Do MMM YYYY, h:mm A",
//               )} and will end on ${Utilities.formatDateTime(
//                 auction?.date_to, //
//                 "Do MMM YYYY, h:mm A",
//               )}.`}
//               textColor="text-black"
//               bold
//             />
//           </div>
//           {auction?.registration_fee != null && auction?.registration_fee > 0 && (
//             <div className="flex gap-2 items-center">
//               <span className="text-lg text-black">
//                 <FontAwesomeIcon icon={faMoneyBill} />
//               </span>
//               <LabelControl
//                 size="medium"
//                 label={`Registration fee: ${Utilities.formatMoney({
//                   value: auction?.registration_fee,
//                   decimalPlaces: 2,
//                 })}`}
//                 textColor="text-black"
//               />
//             </div>
//           )}
//           <PillsControl
//             size="medium"
//             pillSpacing="justify-left"
//             pills={[
//               {
//                 visible: !!auction?.contact_details?.whatsapp?.number,
//                 label: `${auction?.contact_details?.whatsapp?.number}`,
//                 icon: faWhatsapp,
//                 colors: {
//                   iconColor: "text-green-500",
//                 },
//                 onClick: () => {
//                   window.open(`https://wa.me/${auction?.contact_details?.whatsapp?.number}?text=Hello`);
//                 },
//               },
//               {
//                 visible: !!auction?.contact_details?.phone?.number,
//                 label: `${auction?.contact_details?.phone?.number}`,
//                 icon: faPhone,
//                 colors: {
//                   iconColor: "text-blue-500",
//                 },
//                 onClick: () => {
//                   window.open(`tel:${auction?.contact_details?.phone?.number}`);
//                 },
//               },
//               {
//                 visible: !!auction?.contact_details?.email,
//                 label: `${auction?.contact_details?.email}`,
//                 icon: faEnvelope,
//                 colors: {
//                   iconColor: "text-green-500",
//                 },
//                 onClick: () => {
//                   window.open(`mailto:${auction?.contact_details?.email}`);
//                 },
//               },
//             ]}
//             colors={{
//               pills: {
//                 shadowColor: "shadow-gray-200",
//                 backgroundColor: "bg-gray-100",
//               },
//             }}
//           />
//           <div className="flex justify-between mt-2">
//            <div>
//               <span className="text-xl font-bold">Contact Details:</span>
//               <div className="flex gap-2">
//                 <span className="cursor-pointer" onClick={handleWhatsAppShare}>
//                   {whatsappIcon}
//                 </span>
//                 {/* <span className="cursor-pointer" onClick={handleTelegramShare}>
//                   {telegramIcon}
//                 </span> */}
//                 <span className="cursor-pointer" onClick={handleEmailShare}>
//                   {mailIcon}
//                 </span>
//                 <span className="cursor-pointer" onClick={handleSmsShare}>
//                   {msgIcon}
//                 </span>
//                 <span className="cursor-pointer" onClick={handleMapShare}>
//                   {mapIcon}
//                 </span>
//                 <span className="cursor-pointer" onClick={handleCallShare}>
//                   {callingIcon}
//                 </span>
//                 <span className="cursor-pointer" onClick={handleTwitterShare}>
//                   {twitterIcon}
//                 </span>
//               </div>
//             </div> 
//                 </div>
//                 <div className="max-w-[138px] px-6 py-3 bg-[#E2E2E2] rounded-[10px] text-black mt-2 cursor-pointer" onClick={() =>{setIconModal(true)}}>Enquire now</div>
//           </div>
//           </div>
//           {modalIcon && (
//         <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-30 z-50">
//           <div className="bg-white rounded-xl p-4 w-[90%] max-w-sm shadow-lg relative">
//             {/* Header */}
//             <div className="flex justify-between items-center mb-2">
//               <h3 className="text-lg font-semibold">Contact Details</h3>
//               <button className="border border-black rounded-md px-2.5 py-2.5 cursor-pointer" onClick={() => setIconModal(false)}>
//              {crossIcon}
//               </button>
//             </div>
//             <hr />
//             {/* Icons Row */}
//             <div className="flex gap-3 mt-4">
//               <span className="cursor-pointer" onClick={handleWhatsAppEnquiry}>
//                 {whatsappIcon}
//               </span>
//               <span className="cursor-pointer" onClick={handleMailEnquiry}>
//                 {mailIcon}
//               </span>
//               <span className="cursor-pointer" onClick={handleSmsEnquiry}>
//                   {msgIcon}
//                 </span>
//               <span className="cursor-pointer" onClick={handleMapShare}>
//                 {mapIcon}
//               </span>
//               <span className="cursor-pointer" onClick={handleCallEnquiry}>
//                   {callingIcon}
//                 </span>
//             </div>
//           </div>
//         </div>
//       )}
//     </LoaderContent>
//   );
// };
var free_brands_svg_icons_1 = require("@fortawesome/free-brands-svg-icons");
var pro_duotone_svg_icons_1 = require("@fortawesome/pro-duotone-svg-icons");
var pro_solid_svg_icons_1 = require("@fortawesome/pro-solid-svg-icons");
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
var doshx_controls_web_1 = require("doshx_controls_web");
var react_1 = __importStar(require("react"));
var react_redux_1 = require("react-redux");
var get_auction_1 = require("../api/calls/auction/get_auction");
var main_1 = require("../reducers/slices/main");
var gallery_1 = require("./gallery");
var loader_content_1 = require("./loader_content");
var auction_rules_conditions_1 = require("../screens/pages/sign_up/auction_rules_conditions");
var icons_1 = require("../../../assets/icons");
var AuctionDetailsComponent = function (props) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
    // const { auctionID } = props;
    var dispatch = (0, react_redux_1.useDispatch)();
    var _p = (0, react_1.useState)(true), isLoading = _p[0], setIsLoading = _p[1];
    // Use this liveAuction to call the get_auction endpoint.
    // This will get the auction details including the images, documents, etc.
    var liveAuction = (0, react_redux_1.useSelector)(function (state) { return state.auctionState; }).liveAuction;
    var user = (0, react_redux_1.useSelector)(function (state) { return state.userState; }).user;
    var isBidderRegistered = (0, react_redux_1.useSelector)(function (state) { return state.bidderState; }).isBidderRegistered;
    var _q = (0, react_1.useState)(), auction = _q[0], setAuction = _q[1];
    var _r = (0, react_1.useState)(false), modalIcon = _r[0], setIconModal = _r[1];
    (0, react_1.useEffect)(function () {
        if (liveAuction === null || liveAuction === void 0 ? void 0 : liveAuction.entity_id) {
            setIsLoading(true);
            (0, get_auction_1.get_auction)({
                entity_id: liveAuction === null || liveAuction === void 0 ? void 0 : liveAuction.entity_id,
                user_entity_id: user === null || user === void 0 ? void 0 : user.entity_id,
            }).then(function (response) {
                setIsLoading(false);
                if (response.success) {
                    setAuction(response.content);
                }
                else {
                    dispatch((0, main_1.setMessageModal)({
                        title: "Oops!",
                        messages: [
                            "Something went wrong while we were getting the auction details.",
                            response.message,
                        ],
                    }));
                }
            });
        }
    }, [liveAuction === null || liveAuction === void 0 ? void 0 : liveAuction.entity_id]);
    //   const shouldReloadAuctions = useSelector((state: any) => state.auctionState.shouldReloadAuctions);
    // useEffect(() => {
    //   if (shouldReloadAuctions) {
    //     // 👇 Re-run get_auction to get the fresh auction details
    //     if (liveAuction?.entity_id) {
    //       setIsLoading(true);
    //       get_auction({
    //         entity_id: liveAuction?.entity_id,
    //         user_entity_id: user?.entity_id,
    //       }).then((response) => {
    //         setIsLoading(false);
    //         if (response.success) {
    //           setAuction(response.content);
    //         } else {
    //           dispatch(
    //             setMessageModal({
    //               title: "Oops!",
    //               messages: ["Something went wrong while reloading auction details.", response.message],
    //             }),
    //           );
    //         }
    //       });
    //     }
    //     dispatch(setShouldReloadAuctions(false)); // 👈 Reset the flag after refresh
    //   }
    // }, [shouldReloadAuctions, liveAuction?.entity_id]);
    var shareText = "".concat(auction === null || auction === void 0 ? void 0 : auction.title, "\n  Description: ").concat(auction === null || auction === void 0 ? void 0 : auction.description, "\n  Link: ").concat(window.location.href);
    // Convert all images to a newline-separated string
    var imageLinks = (_a = auction === null || auction === void 0 ? void 0 : auction.images) === null || _a === void 0 ? void 0 : _a.map(function (img) { return "\uD83D\uDDBC\uFE0F ".concat(img.uploaded_file_url); }).join("\n");
    // Combine details and images for sharing
    var fullShareText = "".concat(shareText, "\n\n").concat(imageLinks);
    // Share handlers for each platform
    var handleWhatsAppShare = function () { return window.open("https://wa.me/?text=".concat(encodeURIComponent(fullShareText)), "_blank"); };
    var handleTwitterShare = function () { return window.open("https://twitter.com/intent/tweet?text=".concat(encodeURIComponent(fullShareText)), "_blank"); };
    var handleTelegramShare = function () { return window.open("https://t.me/share/url?text=".concat(encodeURIComponent(fullShareText)), "_blank"); };
    var handleEmailShare = function () { return window.open("mailto:?subject=".concat(encodeURIComponent(auction === null || auction === void 0 ? void 0 : auction.title), "&body=").concat(encodeURIComponent(fullShareText))); };
    var handleSmsShare = function () { return window.open("sms:?body=".concat(encodeURIComponent(fullShareText))); };
    var handleMapShare = function () { return window.open("https://maps.google.com?q=".concat(auction === null || auction === void 0 ? void 0 : auction.location.latitude, ",").concat(auction === null || auction === void 0 ? void 0 : auction.location.longitude), "_blank"); };
    var handleCallShare = function () { var _a, _b; return window.open("tel:".concat((_b = (_a = auction === null || auction === void 0 ? void 0 : auction.contact_details) === null || _a === void 0 ? void 0 : _a.phone) === null || _b === void 0 ? void 0 : _b.number)); };
    var handleWhatsAppEnquiry = function () {
        var _a, _b;
        window.open("https://wa.me/".concat((_b = (_a = auction === null || auction === void 0 ? void 0 : auction.contact_details) === null || _a === void 0 ? void 0 : _a.whatsapp) === null || _b === void 0 ? void 0 : _b.number, "?text=Hello"));
    };
    var handleCallEnquiry = function () {
        var _a, _b;
        window.open("tel:".concat((_b = (_a = auction === null || auction === void 0 ? void 0 : auction.contact_details) === null || _a === void 0 ? void 0 : _a.phone) === null || _b === void 0 ? void 0 : _b.number));
    };
    var handleMailEnquiry = function () {
        var _a;
        window.open("mailto:".concat((_a = auction === null || auction === void 0 ? void 0 : auction.contact_details) === null || _a === void 0 ? void 0 : _a.email));
    };
    var handleSmsEnquiry = function () {
        var _a, _b;
        window.open("sms:?body=".concat((_b = (_a = auction === null || auction === void 0 ? void 0 : auction.contact_details) === null || _a === void 0 ? void 0 : _a.phone) === null || _b === void 0 ? void 0 : _b.number));
    };
    return (react_1.default.createElement(loader_content_1.LoaderContent, { loading: isLoading, className: "flex flex-col md:flex-row h-full gap-2" },
        react_1.default.createElement("div", { className: "flex justify-center" },
            react_1.default.createElement(gallery_1.Gallery, { images: (_b = auction === null || auction === void 0 ? void 0 : auction.images) === null || _b === void 0 ? void 0 : _b.map(function (image, index) {
                    return {
                        src: image === null || image === void 0 ? void 0 : image.uploaded_file_url,
                        alt: image === null || image === void 0 ? void 0 : image.title,
                    };
                }) })),
        react_1.default.createElement("div", { className: "flex-1 flex flex-col gap-2 p-4" },
            react_1.default.createElement("div", { className: "flex flex-col gap-2" },
                react_1.default.createElement("div", { className: "flex flex-row justify-between" },
                    react_1.default.createElement("div", null,
                        react_1.default.createElement("div", { className: "text-black text-xl font-bold" }, auction === null || auction === void 0 ? void 0 : auction.title),
                        react_1.default.createElement(doshx_controls_web_1.LabelControl, { size: "xsmall", label: auction === null || auction === void 0 ? void 0 : auction.type, bold: true, textColor: "text-black" })),
                    react_1.default.createElement(doshx_controls_web_1.BadgeControl, { value: auction === null || auction === void 0 ? void 0 : auction.status, colors: {
                            backgroundColor: "bg-[#E53935]",
                            valueColor: "text-white",
                        } })),
                react_1.default.createElement("div", { className: "max-h-[200px] overflow-y-auto" },
                    react_1.default.createElement(doshx_controls_web_1.LabelControl, { size: "large", label: auction === null || auction === void 0 ? void 0 : auction.description, textColor: "text-black" })),
                react_1.default.createElement("div", { className: "h-1 bg-gray-200 py-1 px-4 rounded-full shadow-sm" }),
                !isBidderRegistered && (react_1.default.createElement("div", { className: "flex w-full" },
                    react_1.default.createElement("button", { className: "w-full max-w-[274px] min-h-[37px] rounded-full text-white mt-2 mb-2 text-center ".concat(isBidderRegistered ? "bg-gray-400 cursor-not-allowed" : "bg-[#E53935]"), 
                        // onClick={(e) => handleRegister(e, index, auction.entity_id)}
                        // disabled={loadingIndex === index || auction.auction_registered}
                        onClick: function (e) {
                            e.stopPropagation();
                            // user && user.entity_id
                            //   ?
                            dispatch((0, main_1.setDrawer)({
                                open: true,
                                // content: <RegisterBidderComponent />,
                                content: react_1.default.createElement(auction_rules_conditions_1.AuctionRulesConditionsPage, { registered: auction.auction_registered, auctionId: auction.entity_id }),
                            }));
                            // : dispatch(
                            //     setDrawer({
                            //       open: true,
                            //       content: (
                            //         <div className="w-96">
                            //           <LogInComponent />
                            //         </div>
                            //       ),
                            //     }),
                            //   );
                        }, disabled: isBidderRegistered }, "Register to Bid"))),
                react_1.default.createElement("div", { className: "flex gap-2 items-center" },
                    react_1.default.createElement("span", { className: "text-lg text-black" },
                        react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_duotone_svg_icons_1.faCircleLocationArrow })),
                    react_1.default.createElement("div", { className: "cursor-pointer", onClick: function () {
                            window.open("https://maps.google.com?q=".concat(auction.location.latitude, ",").concat(auction.location.longitude), "_blank");
                        } },
                        react_1.default.createElement(doshx_controls_web_1.LabelControl, { size: "medium", label: (_c = auction === null || auction === void 0 ? void 0 : auction.location) === null || _c === void 0 ? void 0 : _c.full_address, textColor: "text-black" }))),
                react_1.default.createElement("div", { className: "flex gap-2 items-center" },
                    react_1.default.createElement("span", { className: "text-lg text-black" },
                        react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_duotone_svg_icons_1.faCircleCalendar })),
                    react_1.default.createElement(doshx_controls_web_1.LabelControl, { size: "medium", label: "This auction will take place on ".concat(doshx_controls_web_1.Utilities.formatDateTime(auction === null || auction === void 0 ? void 0 : auction.date_from, //
                        "Do MMM YYYY, h:mm A"), " and will end on ").concat(doshx_controls_web_1.Utilities.formatDateTime(auction === null || auction === void 0 ? void 0 : auction.date_to, //
                        "Do MMM YYYY, h:mm A"), "."), textColor: "text-black", bold: true })),
                (auction === null || auction === void 0 ? void 0 : auction.registration_fee) != null && (auction === null || auction === void 0 ? void 0 : auction.registration_fee) > 0 && (react_1.default.createElement("div", { className: "flex gap-2 items-center" },
                    react_1.default.createElement("span", { className: "text-lg text-black" },
                        react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_duotone_svg_icons_1.faMoneyBill })),
                    react_1.default.createElement(doshx_controls_web_1.LabelControl, { size: "medium", label: "Registration fee: ".concat(doshx_controls_web_1.Utilities.formatMoney({
                            value: auction === null || auction === void 0 ? void 0 : auction.registration_fee,
                            decimalPlaces: 2,
                        })), textColor: "text-black" }))),
                react_1.default.createElement("div", { className: "flex  gap-2" },
                    react_1.default.createElement(doshx_controls_web_1.PillsControl, { size: "medium", pills: [
                            {
                                visible: !!((_e = (_d = auction === null || auction === void 0 ? void 0 : auction.contact_details) === null || _d === void 0 ? void 0 : _d.whatsapp) === null || _e === void 0 ? void 0 : _e.number),
                                label: "".concat((_g = (_f = auction === null || auction === void 0 ? void 0 : auction.contact_details) === null || _f === void 0 ? void 0 : _f.whatsapp) === null || _g === void 0 ? void 0 : _g.number),
                                icon: free_brands_svg_icons_1.faWhatsapp,
                                colors: { iconColor: "text-white", textColor: "text-white" },
                                onClick: function () { var _a, _b; return window.open("https://wa.me/".concat((_b = (_a = auction === null || auction === void 0 ? void 0 : auction.contact_details) === null || _a === void 0 ? void 0 : _a.whatsapp) === null || _b === void 0 ? void 0 : _b.number, "?text=Hello")); },
                            },
                        ], colors: {
                            pills: {
                                backgroundColor: "bg-[#4CAF50]",
                                shadowColor: "shadow-gray-200",
                                textColor: "text-white"
                            },
                        } }),
                    react_1.default.createElement(doshx_controls_web_1.PillsControl, { size: "medium", pills: [
                            {
                                visible: !!((_j = (_h = auction === null || auction === void 0 ? void 0 : auction.contact_details) === null || _h === void 0 ? void 0 : _h.phone) === null || _j === void 0 ? void 0 : _j.number),
                                label: "".concat((_l = (_k = auction === null || auction === void 0 ? void 0 : auction.contact_details) === null || _k === void 0 ? void 0 : _k.phone) === null || _l === void 0 ? void 0 : _l.number),
                                icon: pro_duotone_svg_icons_1.faPhone,
                                colors: { iconColor: "text-white", textColor: "text-white" },
                                onClick: function () { var _a, _b; return window.open("tel:".concat((_b = (_a = auction === null || auction === void 0 ? void 0 : auction.contact_details) === null || _a === void 0 ? void 0 : _a.phone) === null || _b === void 0 ? void 0 : _b.number)); },
                            },
                            {
                                visible: !!((_m = auction === null || auction === void 0 ? void 0 : auction.contact_details) === null || _m === void 0 ? void 0 : _m.email),
                                label: "".concat((_o = auction === null || auction === void 0 ? void 0 : auction.contact_details) === null || _o === void 0 ? void 0 : _o.email),
                                icon: pro_solid_svg_icons_1.faEnvelope,
                                colors: { iconColor: "text-white", textColor: "text-white" },
                                onClick: function () { var _a; return window.open("mailto:".concat((_a = auction === null || auction === void 0 ? void 0 : auction.contact_details) === null || _a === void 0 ? void 0 : _a.email)); },
                            },
                        ], colors: {
                            pills: {
                                backgroundColor: "bg-blue-500",
                                shadowColor: "shadow-gray-200",
                                textColor: "text-white"
                            },
                        } })),
                react_1.default.createElement("div", { className: "flex justify-between mt-2" },
                    react_1.default.createElement("div", null,
                        react_1.default.createElement("span", { className: "text-xl font-bold" }, "Contact Details:"),
                        react_1.default.createElement("div", { className: "flex gap-2" },
                            react_1.default.createElement("span", { className: "cursor-pointer", onClick: handleWhatsAppShare }, icons_1.whatsappIcon),
                            react_1.default.createElement("span", { className: "cursor-pointer", onClick: handleEmailShare }, icons_1.mailIcon),
                            react_1.default.createElement("span", { className: "cursor-pointer", onClick: handleSmsShare }, icons_1.msgIcon),
                            react_1.default.createElement("span", { className: "cursor-pointer", onClick: handleMapShare }, icons_1.mapIcon),
                            react_1.default.createElement("span", { className: "cursor-pointer", onClick: handleCallShare }, icons_1.callingIcon),
                            react_1.default.createElement("span", { className: "cursor-pointer", onClick: handleTwitterShare }, icons_1.twitterIcon)))),
                react_1.default.createElement("div", { className: "max-w-[138px] px-6 py-3 bg-[#E2E2E2] rounded-[10px] text-black mt-2 cursor-pointer", onClick: function () {
                        setIconModal(true);
                    } }, "Enquire now"))),
        modalIcon && (react_1.default.createElement("div", { className: "fixed inset-0 flex items-center justify-center bg-black bg-opacity-30 z-50" },
            react_1.default.createElement("div", { className: "bg-white rounded-xl p-4 w-[90%] max-w-sm shadow-lg relative" },
                react_1.default.createElement("div", { className: "flex justify-between items-center mb-2" },
                    react_1.default.createElement("h3", { className: "text-lg font-semibold" }, "Contact Details"),
                    react_1.default.createElement("button", { className: "border border-black rounded-md px-2.5 py-2.5 cursor-pointer", onClick: function () { return setIconModal(false); } }, icons_1.crossIcon)),
                react_1.default.createElement("hr", null),
                react_1.default.createElement("div", { className: "flex gap-3 mt-4" },
                    react_1.default.createElement("span", { className: "cursor-pointer", onClick: handleWhatsAppEnquiry }, icons_1.whatsappIcon),
                    react_1.default.createElement("span", { className: "cursor-pointer", onClick: handleMailEnquiry }, icons_1.mailIcon),
                    react_1.default.createElement("span", { className: "cursor-pointer", onClick: handleSmsEnquiry }, icons_1.msgIcon),
                    react_1.default.createElement("span", { className: "cursor-pointer", onClick: handleMapShare }, icons_1.mapIcon),
                    react_1.default.createElement("span", { className: "cursor-pointer", onClick: handleCallEnquiry }, icons_1.callingIcon)))))));
};
exports.AuctionDetailsComponent = AuctionDetailsComponent;
